import { definePreset } from "@primeuix/themes"
import Aura from '@primeuix/themes/aura';

// Import the SCSS variables
// Note: We need to use the processed values since SCSS variables aren't directly available in JS
const primaryColor = localStorage.getItem('primary_color')
    || '#132c4e';
const accentColor = localStorage.getItem('secondary_color')
    || '#0cbcc6';

    console.log(primaryColor);
    console.log(accentColor);
// Set CSS variables if colors are not default
if (primaryColor !== '#132c4e') {
    document.documentElement.style.setProperty('--primary-color', primaryColor);
}
if (accentColor !== '#0cbcc6') {
    document.documentElement.style.setProperty('--secondary-color', accentColor);
}
const MyPreset = definePreset(Aura, {
    //Your customizations, see the following sections for examples
    primitive: {
        primary: {
            color: primaryColor
        },
        accent: {
            color: accentColor
        }
    },
    semantic: {
        primary: {
            color: primaryColor,
            400: primaryColor
        },
        secondary: {
            color: accentColor,
            400: accentColor
        }
    },
    // Add TabMenu component styling
    components: {
        
    }
});

export default {
    theme: {
        preset: MyPreset,
        options: {
            prefix: 'p',
            darkModeSelector: false,
            /*cssLayer: {
                name: "primevue",
                order: 'tailwind-base, primevue, tailwind-utilities'
            }*/
            cssLayer: false
        }
    }
}

// Configuring Primary and Accent Colors in PrimeVue Theme

//Looking at your PrimeConfig.js file, I can see you're trying to use CSS variables to dynamically apply your primary and accent colors to the PrimeVue theme. This is a great approach for maintaining consistent colors across your application.

//Currently, your code is set up to read CSS custom properties (variables) from the document: